import { gql } from '@apollo/client'

import Address from '../address'

const Order = {
  fragments: {
    deliveryAddress: gql`
      fragment OrderDeliveryAddress on Order {
        deliveryAddress {
          ...Address
        }
      }
      ${Address.fragments.address}
    `,
    invoiceAddress: gql`
      fragment OrderInvoiceAddress on Order {
        invoiceAddress {
          ...Address
        }
      }
      ${Address.fragments.address}
    `
  }
}

export default Order



// WEBPACK FOOTER //
// ./src/graphql/fragments/order/index.js